import Cookies from 'js-cookie';

const { VITE_APP_ENV } = import.meta.env;
const isRealDomain = VITE_APP_ENV === 'production';
const attrs = isRealDomain ? { domain: '.cadexam.com', path: '/' } : { path: '/' };

/**
 * window.localStorage 浏览器永久缓存
 * @method set 设置永久缓存
 * @method get 获取永久缓存
 * @method remove 移除永久缓存
 * @method clear 移除全部永久缓存
 */
export const Local = {
  // 查看 v2.4.3版本更新日志
  setKey(key: string) {
    // @ts-ignore
    return `${__NEXT_NAME__}:${key}`;
  },
  // 设置永久缓存
  set<T>(key: string, val: T) {
    window.localStorage.setItem(Local.setKey(key), JSON.stringify(val));
  },
  // 获取永久缓存
  get(key: string) {
    const json = <string>window.localStorage.getItem(Local.setKey(key));
    return JSON.parse(json);
  },
  // 移除永久缓存
  remove(key: string) {
    window.localStorage.removeItem(Local.setKey(key));
  },
  // 移除全部永久缓存
  clear() {
    window.localStorage.clear();
  },
};

/**
 * window.sessionStorage 浏览器临时缓存
 * @method set 设置临时缓存
 * @method get 获取临时缓存
 * @method remove 移除临时缓存
 * @method clear 移除全部临时缓存
 */
export const Session = {
  // 设置临时缓存
  set<T>(key: string, val: T) {
    if (key === 'access_token' || key === 'admin_access_token' || key === 'refresh_token') {
      Cookies.set(key, val, { ...attrs });
    } else {
      window.sessionStorage.setItem(Local.setKey(key), JSON.stringify(val));
    }
  },
  // 获取临时缓存
  get(key: string) {
    if (key === 'access_token' || key === 'admin_access_token') return Cookies.get(key, { ...attrs });
    const json = <string>window.sessionStorage.getItem(Local.setKey(key));
    return JSON.parse(json);
  },
  // 移除临时缓存
  remove(key: string) {
    if (key === 'access_token' || key === 'admin_access_token' || key === 'refresh_token') {
      document.cookie = 'access_token=; path=/; domain=.ceshi.cadexam.com; expires=' + new Date(0).toUTCString();
      document.cookie = 'access_token=; path=/; domain=ceshi.cadexam.com; expires=' + new Date(0).toUTCString();
      document.cookie = 'access_token=; path=/; domain=.cadexam.com; expires=' + new Date(0).toUTCString();
      document.cookie = 'access_token=; path=/; domain=cadexam.com; expires=' + new Date(0).toUTCString();
      Cookies.remove(key, { ...attrs });
    } else {
      window.sessionStorage.removeItem(Local.setKey(key));
    }
  },
  // 移除全部临时缓存
  clear() {
    document.cookie = '';
    this.remove('access_token');
    this.remove('admin_access_token');
    this.remove('refresh_token');
    window.sessionStorage.clear();
  },
};
